export const setToSessionStorage = (name, data) => {
  sessionStorage.setItem([name], data)
}

export const getFromSessionStorage = (name) => {
  const storageData = sessionStorage.getItem(name)
  return storageData
}

export const removeFromSessionStorage = (name) => {
  sessionStorage.removeItem(name)
}
